import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Input,
  Button,
  Breadcrumb,
  Spin,
  Row,
  Col,
  Select,
  Collapse,
  notification,
  Checkbox,
} from 'antd';
import {
  PlusCircleTwoTone,
  ArrowLeftOutlined,
  HomeOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import _, { isEmpty } from 'lodash';
import API from '../../utils/Api';
import HTMLEditor from '../../utils/jodit-react-component';

const { TextArea } = Input;
const { Option } = Select;
const { Panel } = Collapse;

let editorState;

const Templates = () => {
  const myApi = new API({});
  myApi.createEntity({ name: 'message-template' });
  const [form] = Form.useForm();
  const joditEditor = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [emailvariableCount, setemailVariableCount] = useState(0);
  const [smsvariableCount, setsmsVariableCount] = useState(0);
  const [emailContent, setEmailContent] = useState('');
  const [emailCheck, setEmailCheck] = useState(false);
  const [smsCheck, setSmsCheck] = useState(false);
  const [whatsAppCheck, setWhatsAppCheck] = useState(false);
  const [pushCheck, setPushCheck] = useState(false);
  const [selectedType, setSelectedType] = useState('');

  const handleEmailAddVariable = () => {
    // editorState = joditEditor.current.selection.save();
    setemailVariableCount(emailvariableCount + 1);
  };
  const handleSMSAddVariable = () => {
    setsmsVariableCount(smsvariableCount + 1);
  };

  useEffect(() => {
    if (emailvariableCount) {
      joditEditor.current.component.selection.insertHTML(`<span>{{${emailvariableCount}}}</span>`);
    }
  }, [emailvariableCount]);

  useEffect(() => {
    if (smsvariableCount) {
      const templateValue = form.getFieldValue(['sms_template', 'sms_content']);
      form.setFieldsValue({ sms_template: { sms_content: `${templateValue}{{${smsvariableCount}}}` } });
    }
  }, [smsvariableCount]);
  const onFinish = (values) => {
    setLoadingBtn(true);
    setLoading(true);
    values.app_id = Cookies.get('appID');
    values.template_type = 'all';
    if (selectedType === 'InteractiveButton') {
      values.whatsapp_template.whatsapp_interactive_btn = 1;
    }
    myApi.endpoints.messageTemplate
      .create(values)
      .then(() => {
        notification.success({ message: 'Created successfully.' });
        setLoadingBtn(false);
        setLoading(false);
        form.resetFields();
      })
      .catch((err) => {
        setLoadingBtn(false);
        setLoading(false);
        notification.error({
          message: _.get(err, 'response.data.message', 'Failed to create email template.'),
        });
      });
  };

  const handleCheckChange = (event, name) => {
    const commonTemplateName = form.getFieldValue('template_name');
    const nameChecked = event.target.checked;
    if (name === 'email') {
      setEmailCheck(nameChecked);
      form.setFieldsValue({ email_template: { template_name: nameChecked ? commonTemplateName : '' } });
    } else if (name === 'sms') {
      setSmsCheck(nameChecked);
      form.setFieldsValue({ sms_template: { template_name: nameChecked ? commonTemplateName : '' } });
    } else if (name === 'whatsapp') {
      setWhatsAppCheck(nameChecked);
      form.setFieldsValue({ whatsapp_template: { template_name: nameChecked ? commonTemplateName : '' } });
    } else if (name === 'push') {
      setPushCheck(nameChecked);
      form.setFieldsValue({ push_notification_template: { template_name: nameChecked ? commonTemplateName : '' } });
    }
  };

  const handleSelectType = (value) => {
    setSelectedType(value);
  };

  return (
    <Spin spinning={loading}>
      <div className="search-container">
        <Breadcrumb>
          <Breadcrumb.Item href="/channels"><HomeOutlined /></Breadcrumb.Item>
          <Breadcrumb.Item href="/channels">Channels</Breadcrumb.Item>
          <Breadcrumb.Item>Templates</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="box">
        <div className="box__header">
          <h3 className="box-title">
            <Link to="/channels">
              <ArrowLeftOutlined className="arrow" />
            </Link>
            Add Templates
          </h3>
        </div>
        <div className="box__content p-0">
          <Row>
            <Col span={18} push={2}>
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
              >
                <Form.Item
                  label="Template Name"
                  name="template_name"
                  initialValue=""
                  rules={[
                    {
                      required: true,
                      message: 'Please enter Template name!',
                    },
                    // { min: 3, message: 'Title must be minimum 3 characters.' },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Collapse defaultActiveKey={['1']} destroyInactivePanel>
                  <Panel header="Email Content" key="1">
                    <Form.Item>
                      <Checkbox checked={emailCheck} onChange={(event) => handleCheckChange(event, 'email')}>
                        Use common template name
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      label="Email Template Name"
                      name={['email_template', 'template_name']}
                      initialValue=""
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Email Template name!',
                        },
                        // { min: 3, message: 'Title must be minimum 3 characters.' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
                      <Button icon={<PlusCircleTwoTone />} onClick={handleEmailAddVariable} type="link">Add Email Variable</Button>
                    </Form.Item>
                    <Form.Item
                      label="Email Template Content"
                      name={['email_template', 'email_content']}
                      initialValue=""
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Email content!',
                        },
                        // { min: 3, message: 'Description must be minimum 3 characters.' },
                      ]}
                    >
                      <HTMLEditor
                        onChange={(c) => setEmailContent(c)}
                        config={{ minHeight: 400 }}
                        ref={joditEditor}
                      />
                    </Form.Item>
                  </Panel>
                  <Panel header="SMS Content" key="2">
                    <Form.Item>
                      <Checkbox checked={smsCheck} onChange={(event) => handleCheckChange(event, 'sms')}>
                        Use common template name
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      label="SMS Template Name"
                      name={['sms_template', 'template_name']}
                      initialValue=""
                      rules={[
                        {
                          required: true,
                          message: 'Please enter SMS Template name!',
                        },
                        // { min: 3, message: 'Title must be minimum 3 characters.' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="Template Id"
                      name={['sms_template', 'smstemplate_id']}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter template id',
                        },
                        {
                          validator(rule, value) {
                            const pattern = /^[0-9\b]+$/;
                            if (value && !value.match(pattern)) {
                              return Promise.reject(
                                new Error('Please enter only number'),
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="Sender Id"
                      name={['sms_template', 'sender_id']}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter sender id!',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name={['sms_template', 'sms_type']}
                      label="Purpose"
                      hasFeedback
                      rules={[{ required: 'true', message: 'Please select Purpose!' }]}
                    >
                      <Select placeholder="Please select Puropose" allowClear>
                        <Option value="OTP">OTP</Option>
                        <Option value="MKT">Marketing</Option>
                        <Option value="TXN">Transactional</Option>
                      </Select>
                    </Form.Item>
                    <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
                      <Button
                        icon={<PlusCircleTwoTone />}
                        onClick={handleSMSAddVariable}
                        type="link"
                      >
                        Add SMS Variable
                      </Button>
                    </Form.Item>
                    <Form.Item
                      label="SMS Template Content"
                      name={['sms_template', 'sms_content']}
                      initialValue=""
                      rules={[
                        {
                          required: true,
                          message: 'Please enter the SMS content!',
                        },
                        // { min: 3, message: 'Description must be minimum 3 characters.' },
                      ]}
                    >
                      <TextArea rows={8} maxLength={1000} />
                    </Form.Item>
                  </Panel>
                  <Panel header="WhatsApp Content" key="3">
                    <Form.Item>
                      <Checkbox checked={whatsAppCheck} onChange={(event) => handleCheckChange(event, 'whatsapp')}>
                        Use common template name
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      label="WhatsApp Template Name"
                      name={['whatsapp_template', 'template_name']}
                      initialValue=""
                      rules={[
                        {
                          required: true,
                          message: 'Please enter WhatsApp Template name!',
                        },
                        // { min: 3, message: 'Title must be minimum 3 characters.' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="Select type"
                      name={['whatsapp_template', 'type']}
                      rules={[{ required: 'true', message: 'Please select type' }]}
                    >
                      <Select
                        placeholder="Please select type"
                        onChange={handleSelectType}
                        allowClear
                      >
                        <Option value="Text">Text</Option>
                        <Option value="Media">Media</Option>
                        <Option value="HeaderAndFooter">Header And Footer</Option>
                        <Option value="InteractiveButton">Interactive Button</Option>
                      </Select>
                    </Form.Item>
                    {!isEmpty(selectedType)
                    && (
                    <Form.Item
                      label="WhatsApp Template Content"
                      name={['whatsapp_template', 'whatsapp_content']}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter the WhatsApp content!',
                        },
                        { min: 3, message: 'Description must be minimum 3 characters.' },
                        { message: 'Description must be minimum 3 characters.' },
                      ]}
                    >
                      <Input.TextArea rows={8} maxLength={1000} />
                    </Form.Item>
                    )}
                    {selectedType === 'Media'
                    && (
                    <div>
                      <Form.Item
                        label="Select Media Type"
                        name={['whatsapp_template', 'whatsapp_media_type']}
                        rules={[{ required: 'true', message: 'Please select media type' }]}
                      >
                        <Select
                        placeholder="Please select media type"
                        allowClear
                      >
                        <Option value="Document">Document</Option>
                        <Option value="Image">Image</Option>
                        <Option value="Video">Video</Option>
                      </Select>
                      </Form.Item>
                    </div>
                    )}
                    {selectedType === 'HeaderAndFooter'
                    && (
                    <div>
                      <Form.Item
                        label="WhatsApp header (Optional)"
                        name={['whatsapp_template', 'whatsapp_header']}
                        initialValue=""
                        rules={[
                          { min: 3, message: 'Description must be minimum 3 characters.' },
                          { message: 'Description must be minimum 3 characters.' },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="WhatsApp footer (Optional)"
                        name={['whatsapp_template', 'whatsapp_footer']}
                        initialValue=""
                        rules={[
                          { min: 3, message: 'Description must be minimum 3 characters.' },
                          { message: 'Description must be minimum 3 characters.' },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                    )}
                  </Panel>
                  <Panel header="Push Notification Content" key="4">
                    <Form.Item>
                      <Checkbox checked={pushCheck} onChange={(event) => handleCheckChange(event, 'push')}>
                        Use common template name
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      label="Push Notification Template Name"
                      name={['push_notification_template', 'template_name']}
                      initialValue=""
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Push Notification Template name!',
                        },
                        // { min: 3, message: 'Title must be minimum 3 characters.' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="Push Notification Template Content"
                      name={['push_notification_template', 'notification_content']}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter the Push Notification content!',
                        },
                        { min: 3, message: 'Description must be minimum 3 characters.' },
                        { message: 'Description must be minimum 3 characters.' },
                      ]}
                    >
                      <Input.TextArea rows={8} maxLength={1000} />
                    </Form.Item>
                  </Panel>
                </Collapse>

                <Form.Item style={{ margin: '10px 0px 10px 0px' }}>
                  <Button htmlType="submit" type="primary" disabled={loadingBtn}>
                    {loadingBtn ? 'Submitting...' : 'Submit'}
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </Spin>
  );
};

export default Templates;
